import React from 'react';

const Pricing = ({ property }) => {
  if (!property?.handover_year || property.handover_year.length === 0) {
    return null;
  }

  // Define all possible plans
  const allPlans = [
    {
      title: 'Down Payment',
      value: property.down_payment || '',
    },
    {
      title: 'During Construction',
      value: property.during_construction || '',
    },
    {
      title: 'On Handover',
      value: property.handover_year || '',
    },
    {
      title: 'Post Handover',
      value: property.post_handover || '',
    }
  ];

  // Filter out plans with empty or falsy values
  const validPlans = allPlans.filter(plan => {
    // Check if value exists and is not empty/null/undefined
    return plan.value && plan.value.toString().trim() !== '';
  });

  // If no valid plans, return null
  if (validPlans.length === 0) {
    return null;
  }

  return (
    <div className="container" style={{ paddingBottom: "20px", paddingTop: "30px" }}>
      <h4 className="mb-3">Payment Plan</h4>
      <div className="table-striped" style={{ maxWidth: '100%', width: '100%' }}>
        <table className="table text-center">
          <thead className="table-striped">
            <tr>
              <th>Stage</th>
              {validPlans.map((plan, index) => (
                <th key={index}>{plan.title}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            <tr>
              <td><strong>Percentage</strong></td>
              {validPlans.map((plan, index) => (
                <td key={index}>{plan.value}</td>
              ))}
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default Pricing;